import { render, staticRenderFns } from "./ProductDialog.vue?vue&type=template&id=e65a2b22"
import script from "./ProductDialog.vue?vue&type=script&lang=ts"
export * from "./ProductDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports